<template>
  <div
    class="banner"
    :class="classObject"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'CBanner',

  props: {
    color: {
      type: String,
      default: undefined
    },
    center: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classObject () {
      return {
        'banner--primary': this.color === 'primary',
        'banner--primary-dark': this.color === 'primary-dark',
        'banner--secondary': this.color === 'secondary',
        'banner--secondary-dark': this.color === 'secondary-dark',
        'banner--center': this.center
      }
    }
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.banner--center {
  text-align: center;
}

.banner {
  padding: 0.75em;

  background-color: $color-background;

  > :first-child {
    margin-top: 0;
  }

  > :last-child {
    margin-bottom: 0;
  }
}

.banner--primary {
  color: #fff;
  background-color: $color-primary;
}

.banner--primary-dark {
  color: #fff;
  background-color: $color-primary-dark;
}

.banner--secondary {
  color: #fff;
  background-color: $color-secondary;
}

.banner--secondary-dark {
  color: #fff;
  background-color: $color-secondary-dark;
}
</style>
